import { render, staticRenderFns } from "./orders-calendar.vue?vue&type=template&id=16cc1b85&scoped=true&lang=pug"
import script from "./orders-calendar.vue?vue&type=script&lang=js"
export * from "./orders-calendar.vue?vue&type=script&lang=js"
import style0 from "./orders-calendar.vue?vue&type=style&index=0&id=16cc1b85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cc1b85",
  null
  
)

export default component.exports